import { Alert } from '@cmsgov/ds-medicare-gov'
import { ContentLayout } from 'components/Layouts'
import { MyLink } from 'components/MyLink'
import { useEvent } from 'hooks/useEvent'
import { Trans, useTranslation } from 'react-i18next'

const NoWrapSpan: React.FC = ({ children }) => {
  return <span className="my-u-whitespace-nowrap">{children}</span>
}

function ChangeSubscriptionsLink ({ children }: any) {
  const { fireEvent } = useEvent('accountSettings')

  return (
    <MyLink
      href="https://public.govdelivery.com/accounts/USCMSMYMEDICARE/subscriber/new"
      onClick={({ linkText, linkUrl }) =>
        fireEvent('accountsettings_changeaccountemail2_click', {
          linkText,
          linkUrl
        })
      }
    >
      {children}
    </MyLink>
  )
}

export function DeleteAccountSuccessPage () {
  const { t } = useTranslation('deleteAccount')

  return (
    <ContentLayout heading={t('heading')} width="wide">
      <div className="ds-l-container">
        <Alert
          variation="success"
          heading={t('success.alert.heading')}
          className="ds-u-measure--wide"
        >
          <Trans
            t={t}
            i18nKey={'success.alert.content'}
            components={{
              link1: <ChangeSubscriptionsLink />,
              nowrap: <NoWrapSpan />
            }}
          />
        </Alert>

        <div className="ds-u-margin-top--4">
          <MyLink href="/" className="ds-c-button ds-c-button--solid">
            {t('success.close')}
          </MyLink>
        </div>
      </div>
    </ContentLayout>
  )
}
